<template>
    <div class="dropdown-menu">
        <template v-if="items.length">
            <button
                :class="{ 'is-selected': index === selectedIndex }"
                v-for="(item, index) in items"
                :key="index"
                @click="selectItem(index)"
            >
                {{ item }}
            </button>
        </template>
        <div class="item" v-else>No result</div>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        items: {
            type: Array,
            required: true,
        },

        command: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            selectedIndex: 0,
        };
    },

    watch: {
        items() {
            this.selectedIndex = 0;
        },
    },

    methods: {
        onKeyDown({ event }) {
            if (event.key === "ArrowUp") {
                this.upHandler();
                return true;
            }

            if (event.key === "ArrowDown") {
                this.downHandler();
                return true;
            }

            if (event.key === "Enter") {
                this.enterHandler();
                return true;
            }

            return false;
        },

        upHandler() {
            this.selectedIndex =
                (this.selectedIndex + this.items.length - 1) %
                this.items.length;
        },

        downHandler() {
            this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
        },

        enterHandler() {
            this.selectItem(this.selectedIndex);
        },

        selectItem(index) {
            const item = this.items[index];

            if (item) {
                this.command({ id: item });
            }
        },
    },
};
</script>

<style>
/* Dropdown menu */
.dropdown-menu {
    background: #ffffff;
    border: 1px solid #cfcfcf;
    border-radius: 0.7rem;
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    overflow: auto;
    padding: 12px;
    position: relative;
}

.dropdown-menu button {
    align-items: center;
    background-color: transparent;
    display: flex;
    gap: 0.25rem;
    text-align: left;
    margin-top: 8px;
    padding: 2px 12px;
    border-radius: 6px;
    width: 100%;
}

.dropdown-menu button:hover,
.dropdown-menu button:hover.is-selected {
    background-color: #5805ff0d;
}

.dropdown-menu button.is-selected {
    background-color: #5805ff0d;
}
</style>
